import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'
import TalkdeskFooter from '../../components/TalkdeskFooter'
import TalkdeskNavbar from '../../components/TalkdeskNavbar'

const Base = props => {
  return (
    <Flex
      direction="column"
      alignY="space-between"
      style={{ minHeight: '100vh' }}
    >
      <TalkdeskNavbar
        redirect={props.redirect}
        brandingSettings={props.brandingSettings}
      />
      <Flex width="100%" alignX="center" alignY="center">
        <Box
          paddingX={4}
          paddingY={6}
          className="container-width container-max-width"
        >
          {props.children}
        </Box>
      </Flex>
      <TalkdeskFooter
        brandingSettings={props.brandingSettings}
        showGoogleFooterLink={props.showGoogleFooterLink}
      />
    </Flex>
  )
}

export default Base
